<template>
    <div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>外文官网</el-breadcrumb-item>
          <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{game_name}}链接设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="operating">
        <router-link :to="{path: 'languageGame'}">
          <el-button
            type="primary"
            size="small"
          >返回</el-button>
        </router-link>
        <el-button
          type="primary"
          size="small"
          @click="dialogVisible = true"
        >新增渠道链接</el-button>
      </div>
      <div >
        <template>
          <el-table
            :data="tableData"
            stripe
            center
            border
            highlight-current-row
            style="width: 100%">
            <el-table-column
              align="center"
              label="排序"
              width="80">
              <template slot-scope="scope">
                <el-input  size="small" v-model="scope.row.sequence" @change="changeSort(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="channel.name"
              label="渠道名称">
            </el-table-column>
            <el-table-column
              align="center"
              label="是否显示">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.status?'显示':'不显示'" placement="top">
                  <el-switch
                    v-model="scope.row.status"
                    @change="handleChangeStatus(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#DCDFE6">
                  </el-switch>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="url"
              label="渠道链接">
              <template slot-scope="scope">
                <el-input  size="small" v-model="scope.row.url" @change="linkHandle(scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <el-dialog title="新增渠道链接" :visible.sync="dialogVisible" @close="closeHandle" :close-on-click-modal="false"  width="500px" class="padding_10">
        <el-form :model="form" label-width="80px" :rules="rules" ref="form">
          <el-form-item label="所属渠道" prop="channel_id" >
            <el-select v-model="form.channel_id"  placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in channels"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道链接" prop="url" >
            <el-input v-model="form.url" auto-complete="off" placeholder="请输入渠道链接"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" :loading="loading" @click="store">保 存</el-button>
          <el-button  size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {storeLinkSort, channels, links, storeGameLink} from '../../../api/language/game'

export default {
  data () {
    return {
      game_id: '',
      game_name: '',
      tableData: [],
      channels: [],
      dialogVisible: false,
      loading: false,
      form: {
        channel_id: '',
        url: ''
      },
      rules: {
        channel_id: [
          {required: true, message: '请选择渠道', trigger: 'change'}
        ],
        url: [
          {required: true, message: '请输入渠道链接', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    let id = this.$route.query.id
    let gameName = this.$route.query.name
    if (!id) {
      this.$router.push({path: 'languageGame'})
    }
    this.game_id = id
    this.game_name = gameName
    this.setChannels()
    this.setTableData()
  },
  methods: {
    setChannels () {
      channels().then(res => {
        if (res.status === 2000) {
          this.channels = res.data
        } else {
          this.channels = []
        }
      })
    },
    // 新增
    store () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          storeGameLink({
            game_id: this.game_id,
            url: this.form.url,
            channel_id: this.form.channel_id
          }).then(res => {
            if (res.status === 2000) {
              this.dialogVisible = false
              this.setTableData()
            }
            this.$notify({
              message: res.message,
              type: res.status === 2000 ? 'success' : 'warning',
              offset: 100,
              showClose: false
            })
            this.loading = false
          })
        }
      })
    },
    // 表格数据
    setTableData () {
      links({game_id: this.game_id}).then(res => {
        if (res.status === 2000) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    // 关闭弹窗回调
    closeHandle () {
      this.$refs['form'].resetFields()
    },
    // 排序更改
    changeSort (row) {
      this.changeInfo({
        link_id: row.id,
        sequence: row.sequence
      })
    },
    // 状态切换
    handleChangeStatus (row) {
      this.changeInfo({
        link_id: row.id,
        status: row.status
      })
    },
    linkHandle (row) {
      this.changeInfo({
        link_id: row.id,
        url: row.url
      })
    },
    // 修改信息
    changeInfo (data) {
      storeLinkSort(data).then(res => {
        let {status, message} = res
        this.setTableData()
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/language/game/link.vue